var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedArtistSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/verified-artist-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0.0003125%",
    cy: "50.0015625%",
    fx: "0.0003125%",
    fy: "50.0015625%",
    r: "100%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C7DFC",
    offset: "69.6705638%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.12834038,0.19549779 C7.38855977,-0.0649818153 7.8106697,-0.0651927648 8.0711493,0.195026621 C8.33162891,0.455246006 8.33183986,0.87735594 8.07162047,1.13783554 L2.7383022,6.47648714 C2.47799085,6.7370588 2.05569916,6.73716432 1.79525763,6.47672278 L0.195262146,4.8767273 C-0.065087382,4.61637777 -0.065087382,4.19426779 0.195262146,3.93391826 C0.455611674,3.67356873 0.87772166,3.67356873 1.13807119,3.93391826 L2.26666667,5.062 L7.12834038,0.19549779 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/verified-artist-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6648744,22.7357282 C10.0164133,23.2036481 9.11140769,23.0572905 8.64348781,22.4088294 C8.60728822,22.3586626 8.574341,22.3062274 8.54484872,22.2518462 C8.07621541,21.3877263 7.10681969,20.9208899 6.13903551,21.0932676 C5.35176941,21.2334921 4.59988972,20.7089613 4.4596652,19.9216952 C4.44881704,19.8607901 4.4418834,19.7992523 4.43890691,19.7374603 C4.39161044,18.7555828 3.72076779,17.9143727 2.77403252,17.6497738 C2.00388914,17.4345298 1.55405434,16.6357154 1.76929837,15.8655721 C1.78595026,15.8059916 1.80640349,15.7475396 1.83053233,15.6905755 C2.21394034,14.7854133 1.97451937,13.7364415 1.23634554,13.087273 C0.635861214,12.5591922 0.577166614,11.6443093 1.10524748,11.043825 C1.14610129,10.9973699 1.18989039,10.9535808 1.23634554,10.912727 C1.97451937,10.2635585 2.21394034,9.2145867 1.83053233,8.30942452 C1.51864035,7.57309972 1.86271113,6.72335212 2.59903593,6.41146014 C2.65600008,6.38733131 2.71445207,6.36687807 2.77403252,6.35022619 C3.72076779,6.08562725 4.39161044,5.24441717 4.43890691,4.26253973 C4.47738131,3.46380915 5.15607003,2.84749974 5.95480061,2.88597413 C6.01659265,2.88895062 6.0781304,2.89588426 6.13903551,2.90673242 C7.10681969,3.07911005 8.07621541,2.61227368 8.54484872,1.74815384 C8.92606916,1.04521587 9.8049532,0.784412277 10.5078912,1.16563272 C10.5622724,1.195125 10.6147076,1.22807222 10.6648744,1.26427181 C11.462026,1.83948451 12.537974,1.83948451 13.3351256,1.26427181 C13.9835867,0.796351933 14.8885923,0.942709514 15.3565122,1.59117062 C15.3927118,1.64133738 15.425659,1.69377259 15.4551513,1.74815384 C15.9237846,2.61227368 16.8931803,3.07911005 17.8609645,2.90673242 C18.6482306,2.7665079 19.4001103,3.29103874 19.5403348,4.07830484 C19.551183,4.13920994 19.5581166,4.2007477 19.5610931,4.26253973 C19.6083896,5.24441717 20.2792322,6.08562725 21.2259675,6.35022619 C21.9961109,6.56547022 22.4459457,7.36428455 22.2307016,8.13442793 C22.2140497,8.19400838 22.1935965,8.25246037 22.1694677,8.30942452 C21.7860597,9.2145867 22.0254806,10.2635585 22.7636545,10.912727 C23.3641388,11.4408078 23.4228334,12.3556907 22.8947525,12.956175 C22.8538987,13.0026301 22.8101096,13.0464192 22.7636545,13.087273 C22.0254806,13.7364415 21.7860597,14.7854133 22.1694677,15.6905755 C22.4813597,16.4269003 22.1372889,17.2766479 21.4009641,17.5885399 C21.3439999,17.6126687 21.2855479,17.6331219 21.2259675,17.6497738 C20.2792322,17.9143727 19.6083896,18.7555828 19.5610931,19.7374603 C19.5226187,20.5361909 18.84393,21.1525003 18.0451994,21.1140259 C17.9834074,21.1110494 17.9218696,21.1041157 17.8609645,21.0932676 C16.8931803,20.9208899 15.9237846,21.3877263 15.4551513,22.2518462 C15.0739308,22.9547841 14.1950468,23.2155877 13.4921088,22.8343673 C13.4377276,22.804875 13.3852924,22.7719278 13.3351256,22.7357282 C12.537974,22.1605155 11.462026,22.1605155 10.6648744,22.7357282 Z",
    id: "Star",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/tick-small-white",
    transform: "translate(7.733353, 8.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-3)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.733353, -4.666667)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedArtistSmall);
export default __webpack_public_path__ + "static/media/verified-artist-small.9e05df5ec14e6dff570b2bb55e6cd7f2.svg";
export { ForwardRef as ReactComponent };